// extracted by mini-css-extract-plugin
export var author = "note-module--author--053a8";
export var category = "note-module--category--beef8";
export var headline = "note-module--headline--daa32";
export var headlinePost = "note-module--headline-post--35108";
export var note = "note-module--note--7e9c3";
export var noteIcon = "note-module--noteIcon--370fc";
export var paragraph = "note-module--paragraph--be0f2";